<template>
  <div>
    <div class="mb-2">
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-success"
        @click="openFeeSetting()"
        :disabled="disabled"
        ><i class="el-icon-plus" />添加
      </b-button>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-danger"
        @click="del()"
        :disabled="disabled"
        ><i class="el-icon-delete" />删除
      </b-button>
    </div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight - 111"
      :expand-config="{}"
      size="mini"
      border
      resizable
    >
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
      <template v-slot:expandContent="{ row }">
        <charters-setting
          disabled
          :contractChartersCode="row.contractChartersCode"
        />
      </template>
      <template v-slot:opt="{ row }">
        <el-button
          type="text"
          :disabled="disabled"
          @click="openFeeSetting(row.contractChartersCode)"
          >编辑</el-button
        ></template
      >
    </vxe-grid>
    <charters-edit-form-dialog
      :visible.sync="openChartersOptions.visible"
      v-if="openChartersOptions.visible"
      :contractCarrierCode="contractCarrierCode"
      :contractChartersCode="openChartersOptions.code"
      @success="getData"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import ChartersEditFormDialog from '../charters-edit-form/dialog'
import ChartersSetting from '../charters-setting'
export default {
  components: {
    ChartersEditFormDialog,
    ChartersSetting
  },
  mixins: [BaseTable, TableAutoHeight],
  props: {
    disabled: Boolean,
    contractCarrierCode: String
  },
  data() {
    return {
      usePage: true,
      tableData: [],
      tableColumns: tableColumns(),
      showFeeSettingDialog: false,
      openChartersOptions: { visible: false, code: ''}
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.contractCarrierCode) return
      this.$api
        .contractCarrierChartersListApi({
          contractCode: this.contractCarrierCode,
          ...this.page
        })
        .then((res) => {
          this.setData(res)
        })
    },
    del() {
      this.$confirm('是否确认删除选中的数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const records = this.$refs.table.getCheckboxRecords(true) || []
          if (!records || !records.length) {
            this.$message.warning('请先选择要删除的包车费用！')
            return
          }
          const codes = records.map((r) => r.contractChartersCode)
          this.$api
            .contractCarrierChartersDelApi({ contractChartersCodeList: codes })
            .then((res) => {
              const { status, msg } = res
              this.$message({
                type: status === 200 ? 'success' : 'error',
                message: msg
              })
              this.getData()
            })
        })
        .catch(() => {})
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.getData()
    },
    openFeeSetting(code = '') {
      this.openChartersOptions.code = code
      this.openChartersOptions.visible = true
    }
  }
}
</script>
